import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ConfirmationButtonOptionModel} from '../../../../components/common/button/confirmation-button/model/confirmationButtonOption.model';
import {IWithPermissionModel} from '../../../common/permission/api/entity/iWithPermission.model';
import {BaseActionService} from '../../service/v2/service/action/baseAction.service';
import {BaseView} from '../../view/base.view';
import {ActionServiceContainerComponent} from "../action-service-container/action-service-container.component";

@Component({
    selector: 'app-action-button',
    templateUrl: './action-button.component.html',
})
export class ActionButtonComponent<Payload> extends BaseView implements OnInit {

    @ViewChild('actionServiceContainer') actionServiceContainer: ActionServiceContainerComponent<any>;
    @Input() size: string;
    @Input() label: string;
    @Input() iconName: string;
    @Input() fill : 'clear' | 'solid' = 'clear';
    @Input() disabled = false;
    @Input() withPadding = true;
    @Input() withMargin = true;
    @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
    @Input() actionSuccessMessage = 'Modifications effectuées';
    @Input() actionErrorMessage = 'Une erreur est survenue';
    @Input() service: BaseActionService<Payload, any>;
    @Input() buildPayload: (entity: any) => Payload;
    @Input() confirmationOptions: ConfirmationButtonOptionModel = new ConfirmationButtonOptionModel();
    @Input() entity: any;
    @Input() permission: string;
    @Input() tooltip: string;
    @Input() hideIfNoPermission = false;

    @Output() actionTriggeredEvent: EventEmitter<void> = new EventEmitter();
    @Output() actionErrorEvent: EventEmitter<any> = new EventEmitter();
    @Output() actionSuccessEvent: EventEmitter<any> = new EventEmitter();

    // loading = false;

    constructor() {
        super();
    }

    ngOnInit() {
    }

    executeAction() {
        this.actionTriggeredEvent.emit();
        this.actionServiceContainer?.executeAction()
    }
}
